import { change_Lang } from "../../actions/actionConstants";

const localStorageKey = "react-ecg-report redux.state.app.settings.lang";
const defaultLang = "RU";

const load = () => {
    try {
        const lang = localStorage.getItem(localStorageKey);
        return lang || defaultLang;
    } catch (err) {
        return defaultLang;
    }
};

const save = lang => {
    localStorage.setItem(localStorageKey, lang);
};
const updateLanguage = (state, action) => {
    if (state === undefined) return load();

    switch (action.type) {
        case change_Lang:
            save(action.payload);
            return action.payload;

        default:
            return state.app.settings.lang;
    }
};

export default updateLanguage;
